import store from "../store/index";
import axios from "axios";

export async function runGraphqlQuery(queryString, signal = null) {
  const currentToken = store.getters["user/currentToken"];
  const currentAgencyId = store.getters["agency/currentAgencyId"];

  const headers = {
    Authorization: `Bearer ${currentToken}`,
    "Content-Type": "application/graphql",
    "x-agency-id": currentAgencyId,
  };

  return axios.post(process.env.VUE_APP_GRAPHQL_API, queryString, { headers, signal });
}

export function getBaseGraphqlServerUrl() {
  return process.env.VUE_APP_GRAPHQL_API.replace(
    /\/graphql(?!.*\/graphql)/,
    ""
  );
}

export function stringifyFilter(arr) {
  return (
    "[" +
    arr
      .map((obj) => {
        return (
          "{" +
          Object.entries(obj)
            .map(([key, value]) => {
              const formattedValue =
                typeof value === "string" ? `"${value}"` : value;
              return `${key}:${formattedValue}`;
            })
            .join(", ") +
          "}"
        );
      })
      .join(", ") +
    "]"
  );
}

export function formatNumber(num) {
  if (num) {
    if (num >= 10000000) {
      return (num / 10000000).toFixed(2).replace(/\.00$/, "") + " crore";
    } else if (num >= 1000000) {
      return (num / 100000).toFixed(2).replace(/\.00$/, "") + "lac";
    } else if (num >= 1000) {
      return (num / 1000).toFixed(2).replace(/\.00$/, "") + "k";
    } else {
      return num.toString();
    }
  } else {
    return 0;
  }
}

export function formatDuration(seconds) {
  if (!seconds) return "-";

  seconds = parseInt(seconds);

  const hours = Math.floor(seconds / 3600);
  seconds %= 3600;
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = seconds % 60;

  let formattedDuration = "";
  if (hours > 0) {
    formattedDuration += `${hours}h `;
  }
  if (minutes > 0) {
    formattedDuration += `${minutes}m `;
  }
  if (remainingSeconds > 0 || formattedDuration === "") {
    formattedDuration += `${remainingSeconds}s`;
  }

  return formattedDuration.trim();
}

export function downloadCSV(blob, filename = "export-conversations.csv") {
  const url = window.URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  window.URL.revokeObjectURL(url);
  document.body.removeChild(a);
}
